import AnnouncementSlide from "@/components/worship/AnnouncementSlide";
const THEMES = {
  dark: { bg: "#000000", fg: "#FFFFFF", sub: "rgba(255,255,255,0.45)" },
  light: { bg: "#F7F5EF", fg: "#111111", sub: "rgba(17,17,17,0.5)" },
};

export default function Stage({ slide, meta, settings, blank, testId = "projection-stage", className = "" }) {
  const t = THEMES[settings.theme] || THEMES.dark;
  const lines = (slide?.text || "").split("\n");
  return (
    <div data-testid={testId} className={`hymn-protect relative w-full aspect-video overflow-hidden select-none ${className}`}
      style={{ background: t.bg, color: t.fg, containerType: "size" }}>
      {!blank && slide?.kind === "announcement" && <AnnouncementSlide a={slide.ann} />}
      {!blank && slide?.kind === "image" && <img src={slide.src} alt="" className="absolute inset-0 w-full h-full object-contain bg-white" draggable={false} />}
      {!blank && slide && !["announcement", "image"].includes(slide.kind) && (
        <div className="absolute inset-0 flex flex-col justify-center" style={{ padding: "6cqh 7cqw", textAlign: settings.align }}>
          <div data-testid={`${testId}-text`} style={{ fontSize: `${settings.fontScale}cqh`, lineHeight: 1.3, fontWeight: 600, letterSpacing: "0.01em" }}>
            {lines.map((l, i) => <div key={i}>{l || "\u00A0"}</div>)}
          </div>
        </div>
      )}
      {!blank && slide && slide.kind !== "announcement" && slide.kind !== "image" && settings.showFooter && meta && (
        <div className="absolute bottom-0 inset-x-0 flex justify-between" style={{ padding: "0 4cqw 3cqh", fontSize: "2.6cqh", color: t.sub }}>
          <span>{meta.number} · {meta.title}</span>
          <span>{meta.position}</span>
        </div>
      )}
    </div>
  );
}
